import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  fetchingResults: false,
  fetchError: null,
  page: null,
  types: [],
  results: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.VIEW_APPLICATION_DISTRIBUTION_FETCH_SUCCESS:
      return {
        ...state,
        types: payload,
      };
    case types.VIEW_APPLICATION_DISTRIBUTION_FETCH_RECORDS_SUCCESS:
      return {
        ...state,
        results: payload,
      };
    case types.VIEW_APPLICATION_DISTRIBUTION_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.VIEW_APPLICATION_DISTRIBUTION_FETCHING_RESULTS:
      return {
        ...state,
        fetchingResults: payload,
      };

    case types.VIEW_APPLICATION_DISTRIBUTION_FETCH_ERROR:
      return {
        ...state,
        fetchError: payload,
      };

    case types.VIEW_APPLICATION_DISTRIBUTION_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/viewapplicationdistribution/state/reducer.js